import React, { useContext, useEffect } from "react";
import loadable from "@loadable/component";
import { Redirect, Route, Switch } from "react-router";
import Header from "./Components/Common/Header";
import { decodeToken } from "./Components/Common/DecodeToken";
import myContext from "./Components/Context/myContext";

const Home = loadable(() => import("./Components/Home Page/Home"));
const About = loadable(() => import("./Components/About Page/About"));
const Service = loadable(() => import("./Components/Service Page/Service"));
const Contact = loadable(() => import("./Components/Contact Page/Contact"));
const Login = loadable(() => import("./Components/Login Page/Login"));
const Logout = loadable(() => import("./Components/Login Page/Logout"));
const Admin = loadable(() => import("./Components/Admin Panel Page/Admin"));
const Page404 = loadable(() => import("./Components/Common/404"));

function App() {
    const context = useContext(myContext);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = decodeToken(token);
            const dateNow = Date.now() / 1000;
            if (decodedToken.payload.exp < dateNow) {
                localStorage.removeItem("token");
                context.LogOutAdmin();
            } else if (decodedToken.payload.keyToken === "@dfAG4^#sBhdY0o0O#df") {
                context.LogInAdmin();
            }
        }
    }, []);

    return (
        <>
            <Header />
            <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/about" component={About} />
                <Route path="/service" component={Service} />
                <Route path="/contact" component={Contact} />
                <Route path="/login" component={Login} />
                <Route path="/logout" render={() => (context.AdminPresent === false ? <Redirect to="/" /> : <Logout />)} />
                <Route path="/Admin" component={Admin} />
                <Route component={Page404} />
            </Switch>
        </>
    );
}

export default App;
